/*
 *
 * ProcessingRulesPopup
 *
 * @version 1.0.0
 * @author Alessandro Mosca
 * @since 23-Jan-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useFormik } from 'formik'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import ProcessingRulesForm from 'Components/ProcessingRulesForm'
import { processingRulesSchema } from 'Schemas/processingRulesSchemaYup'
import { getYupSchema } from 'Schemas/yup'
import { processingRules } from './languageModule'
import './ProcessingRulesPopup.scss'

const ProcessingRulesPopup = ({ actions, action, isLoading }) => {
  const intl = useIntl()

  const formik = useFormik({
    initialValues: {
      ruleName: '',
      processingRulesType: '',
      processingRulesStatus: true,
      value: ''
    },
    validateOnMount: true,
    isInitialValid: false,
    enableReinitialize: true,
    validationSchema: getYupSchema(processingRulesSchema, intl, [
      'ruleName',
      'processingRulesType',
      'processingRulesStatus',
      'value'
    ])
  })

  const onSubmit = (values) => {
    actions.submitForm({ name: 'ProcessingRulesForm', data: values })
    actions.doCreateProcessingRules()
  }
  return (
    <MerchantModal
      closeLabel={intl.formatMessage(processingRules.close)}
      bigPopup
      topBarTitle={
        action === 'create'
          ? intl.formatMessage(processingRules.ruleSettings)
          : intl.formatMessage(processingRules.manageTitle)
      }
      primaryButtonLabel={
        action === 'create' ? intl.formatMessage(processingRules.create) : intl.formatMessage(processingRules.confirm)
      }
      primaryButtonDisabled={!formik.isValid}
      primaryButtonLoading={isLoading}
      onClose={() => actions.closeProcessingRulesPopup()}
      hideResetFilter
      primaryAction={() => onSubmit(formik.values)}>
      <MerchantGenericCard>
        <div className='processing_rules_popup_content'>
          <ProcessingRulesForm formik={formik} />
        </div>
      </MerchantGenericCard>
    </MerchantModal>
  )
}

ProcessingRulesPopup.propTypes = { actions: PropTypes.object, action: PropTypes.string, isLoading: PropTypes.bool }

ProcessingRulesPopup.defaultProps = {
  actions: {},
  action: '',
  isLoading: false
}

export default ProcessingRulesPopup
